import React, { ReactElement } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'

const BoxPlotEditor = (): ReactElement => {
    return (
        <EditorContainer className="editor-container default-editor">
            <EditorDefaultMessage />
        </EditorContainer>
    )
}

const EditorDefaultMessage = (): ReactElement => (
    <DefaultEditorMessageContainer>
        <DefaultEditorMessageText className="asset-selector__empty__text">
            {i18n('Filters and settings are displayed in visualization mode only.')}
            <br />
            {i18n('Save this widget and return to the dashboard.')}
        </DefaultEditorMessageText>
    </DefaultEditorMessageContainer>
)

const Editor = (
    widgetConfigStore: Record<string, any>,
    widgetConfigActions: Record<string, any>,
    widgetDataStore: Record<string, any>,
    widgetDataActions: Record<string, any>,
    meta: Array<any>
) => {
    return function EditorWrapper(props): ReactElement {
        return (
            <BoxPlotEditor
                widgetConfigStore={widgetConfigStore}
                widgetDataActions={widgetDataActions}
                widgetConfigActions={widgetConfigActions}
                widgetDataStore={widgetDataStore}
                meta={meta}
                {...props}
            />
        )
    }
}

const DefaultEditorMessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 5%;
`

const DefaultEditorMessageText = styled.div`
    color: #666;
    font-size: 36px;
    font-style: italic;
    line-height: normal;
    text-align: center;
`

const EditorContainer = styled.div`
    display: flex;
    flex: 1 1 auto;
    > div:first-child {
        width: 100%;
    }
    .widget-footer {
        position: absolute !important;
        left: 0;
        bottom: 0;
    }
    .widget-content-container {
        padding: 0 !important;
        background-color: ${({ theme }) => theme['gray-lighter']};
        .highcharts-legend > rect {
            fill: none !important;
        }
    }
    .widget-header {
        display: none;
    }
`

export default Editor
